module.exports = __webpack_public_path__ + "static/media/edit.d1142549.svg";